module.exports = __webpack_public_path__ + "static/media/Logo__SCIS.37ee8e26.svg";